import {ModalDialog} from "@/scripts/theme/modal-dialog";
import {
  ATTRIBUTES,
  SELECTORS
} from "@/scripts/core/global";
import { TsDOM as q } from '@/scripts/core/TsDOM'
import type {CartDrawer} from "@/scripts/cart/cart-drawer";

export class CartOptionsModal extends ModalDialog {
  static override htmlSelector = 'cart-options-modal'

  constructor() {
    super()
  }

  override hide(preventFocus = false) {
    const cartNotification = q.rs<CartDrawer>('cart-drawer')
    if (cartNotification && this.openedBy)
      cartNotification.setActiveElement(this.openedBy)

    const openedByLoader = q.os('[data-uc-loading-overlay-spinner]', this.openedBy)
    if (openedByLoader) {
      openedByLoader.classList.add('hidden')
    }
    if (preventFocus) this.openedBy = undefined
    super.hide()
  }

  override show(opener: HTMLElement) {
    opener.setAttribute('aria-disabled', 'true')
    opener.setAttribute(ATTRIBUTES.loading, '')
    q.rs(SELECTORS.loadingOverlaySpinner, opener).classList.remove(
      'hidden'
    )
    super.show(opener)
  }

}
